import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useMemo, useCallback } from 'react';
import { eventBus } from '../events';
const ProjectDataContext = createContext(undefined);
export const ProjectDataProvider = ({ children, projects, selectedProject, folders, artifacts, folderTree, loading, onSelectProject }) => {
    // Memoize loadProjectStructure since it doesn't depend on any props
    const loadProjectStructure = useCallback((projectId) => {
        eventBus.emit('data:refreshProjectStructure', { projectId });
    }, []);
    // Memoize actions to prevent unnecessary re-renders and effect triggers
    const actions = useMemo(() => ({
        selectProject: onSelectProject,
        loadProjectStructure
    }), [onSelectProject, loadProjectStructure]);
    // Memoize the entire context value
    const value = useMemo(() => ({
        projects,
        selectedProject,
        folders,
        artifacts,
        folderTree,
        loading,
        actions
    }), [projects, selectedProject, folders, artifacts, folderTree, loading, actions]);
    return (_jsx(ProjectDataContext.Provider, { value: value, children: children }));
};
export const useProjectData = () => {
    const context = useContext(ProjectDataContext);
    if (context === undefined) {
        throw new Error('useProjectData must be used within a ProjectDataProvider');
    }
    return context;
};
